import clsx from 'clsx';
import {ComponentPropsWithoutRef, HTMLAttributes, ReactNode} from 'react';
import {Spinner} from "react-bootstrap";

type LayoutProps = ComponentPropsWithoutRef<'div'> & HTMLAttributes<HTMLDivElement> & {
	children: ReactNode;
  loading?: boolean;
	[x: string]: any;
};

type WrapperProps = LayoutProps & {
	Left?: ReactNode;
	Main?: ReactNode;
	Content?: ReactNode;
	Form?: ReactNode;
	Action?: ReactNode;
};

const Left = ({ children, className, ...props }: LayoutProps) => {
	return (
		<div className={clsx('spaces w-20 mh-100 overflow-y-auto', className)} {...props}>
			{children}
		</div>
	);
};

const Main = ({ children, className, ...props }: LayoutProps) => {
	return (
		<div className={clsx('flex-1', className)} {...props}>
			{children}
		</div>
	);
};

const Content = ({ children, className, loading = false, ...props }: LayoutProps) => {
	return (
		<div
			className={clsx('d-flex flex-column justify-content-between h-100 position-relative', className)}
			{...props}
		>
      {loading && (
        <div className="flex-center-middle position-absolute w-100 h-100 z-index-1500 spaces bg-gray-200 bg-opacity-75">
          <Spinner animation="border" role="status" variant="primary"/>
        </div>
      )}
			{children}
		</div>
	);
};

const Form = ({ children, className, ...props }: LayoutProps) => {
	return (
		<div className={clsx('spaces h-100 p-8 overflow-y-auto overflow-x-hidden', className)} {...props}>
			{children}
		</div>
	);
};

const Action = ({ children, className, ...props }: LayoutProps) => {
	return (
		<div
			className={clsx(
				'd-flex justify-content-between align-items-center',
				'position-sticky bottom-0',
				'bg-white spaces p-8',
				'border-top',
				className
			)}
			{...props}
		>
			{children}
		</div>
	);
};

const PhieuLayout = ({ children, className, ...props }: WrapperProps) => {
	return <div className={clsx("d-flex h-100", className)} {...props}>{children}</div>;
};

PhieuLayout.Left = Left;
PhieuLayout.Main = Main;
PhieuLayout.Content = Content;
PhieuLayout.Form = Form;
PhieuLayout.Action = Action;

export default PhieuLayout;
